import React from 'react';

import { DrawerInfo, ButtonRefuseOffering } from 'components';
import { colorByPartner } from 'helpers/getColorPartner';
import { Button, Grid, TextField, Typography } from '@material-ui/core';

const DrawerRefuseOffering = props => {
  const { open, setOpen, cancel, closeButton = true } = props;

  const [values, setValue] = React.useState('Pinjaman terlalu sedikit');
  const [isActives, setIsActives] = React.useState([
    true,
    false,
    false,
    false,
    false
  ]);

  const onClick = (key, value) => {
    const updatedIsActives = isActives.map((_, index) => index === key);
    setIsActives(updatedIsActives);
    setValue(value);
  };

  const buttonsConfig = [
    {
      title: 'Pinjaman terlalu sedikit',
      onClicked: onClick,
      isActive: isActives[0],
      index: 0,
      value: 'Pinjaman terlalu sedikit'
    },
    {
      title: 'Cicilan terlalu mahal',
      onClicked: onClick,
      isActive: isActives[1],
      index: 1,
      value: 'Cicilan terlalu mahal'
    },
    {
      title: 'Sudah dapat pinjaman dari aplikasi lain',
      onClicked: onClick,
      isActive: isActives[2],
      index: 2,
      value: 'Sudah dapat pinjaman dari aplikasi lain'
    },
    {
      title: 'Jangka waktu tidak sesuai',
      onClicked: onClick,
      isActive: isActives[3],
      index: 3,
      value: 'Jangka waktu tidak sesuai'
    },
    {
      title: 'Alasan lainnya',
      onClicked: onClick,
      isActive: isActives[4],
      index: 4,
      value: ''
    }
  ];

  const renderButtonDrawer = button => {
    const { title, onClicked, index, isActive, value } = button;

    return (
      <Grid item key={value}>
        <ButtonRefuseOffering
          index={index}
          isActive={isActive}
          key={values}
          onclick={onClicked}
          title={title}
          value={value}
        />
      </Grid>
    );
  };

  return (
    <DrawerInfo
      closeButton={closeButton}
      onActionHandler={() => setOpen(prevState => !prevState)}
      opened={open}
      setOpened={() => setOpen(false)}
    >
      <Grid container direction="column" spacing={2}>
        <Grid alignItems="center" container direction="column" item>
          <Grid item>
            <img alt="disburse" src="/images/assets/refuse_offering.svg" />
          </Grid>
        </Grid>
        <Grid container direction="column" item>
          <Grid item>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="subtitle1"
            >
              Pilih alasan penolakan
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          spacing={1}
          style={{ margin: '16px 0px' }}
        >
          {buttonsConfig.map(renderButtonDrawer)}
        </Grid>
        {isActives[4] === true && (
          <Grid container direction="column">
            <Grid item style={{ padding: '8px 16px' }}>
              <TextField
                autoComplete="off"
                fullWidth
                id="standard-textarea"
                inputProps={{
                  maxLength: 255
                }}
                label="Alasan penolakan pinjaman"
                multiline
                onChange={e => {
                  setValue(e.target.value);
                }}
                rows={4}
                variant="filled"
              />
            </Grid>
          </Grid>
        )}
        <Grid container direction="row" item spacing={1}>
          <Grid item xs={6}>
            <Button
              fullWidth
              onClick={() => cancel(values)}
              style={{
                color: colorByPartner,
                border: `1px solid ${colorByPartner}`
              }}
              variant="contained"
            >
              Tolak Penawaran
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              color="secondary"
              fullWidth
              onClick={() => setOpen(prevState => !prevState)}
              variant="contained"
            >
              Kembali
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </DrawerInfo>
  );
};

export default DrawerRefuseOffering;
